// Runtime configuration loaded from window.__RUNTIME_CONFIG__ (set by /env.js)
// Falls back to process.env for development, then empty string

const runtimeConfig =
  typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ || {} : {};

const getConfigValue = (key, fallback = "") => {
  const value = runtimeConfig[key];
  if (typeof value === "string" && value.trim() !== "") {
    return value;
  }
  return fallback;
};

export const API_URL = getConfigValue(
  "REACT_APP_API_URL",
  process.env.REACT_APP_API_URL || "",
);

if (!API_URL) {
  console.error(
    "Missing runtime config: REACT_APP_API_URL. Check /env.js generation and environment variable injection.",
  );
}
